"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.askAnAgentList = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Pages_1 = require("@/rendering/common/Pages");
var AboutPage_1 = require("@/pages/common/components/AboutPage");
var AskAnAgentListAction_1 = require("@/pages/askAnAgentList/actions/AskAnAgentListAction");
var format_1 = require("@/utils/format");
var ResultPagination_1 = require("@/pages/search/components/ResultPagination");
var AskAnAgentListUrl_1 = require("@/pages/askAnAgentList/sagas/api/AskAnAgentListUrl");
var classNames = require("classnames");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.askAnAgentList), { menu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.RESOURCES; })[0] })); };
var mapDispatchToProps = function (dispatch) { return ({
    onKeywordChanged: function (keyword) {
        return dispatch(AskAnAgentListAction_1.default.onSetKeyword(keyword));
    },
    onChangePage: function (n) { return dispatch(AskAnAgentListAction_1.default.onChangePage(n)); },
    onKeywordFocus: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordFocus()); },
    setKeywordBlur: function (element) {
        return dispatch(AskAnAgentListAction_1.default.setKeywordBlur(element));
    },
    onKeywordBlur: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordBlur()); },
    onKeywordEnter: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordEnter()); },
    onKeywordSelect: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordSelect()); },
    onKeywordArrowUp: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordArrowUp()); },
    onKeywordArrowDown: function () { return dispatch(AskAnAgentListAction_1.default.onKeywordArrowDown()); },
    onSuggestItemClick: function (i) {
        return dispatch(AskAnAgentListAction_1.default.onSuggestItemClick(i));
    },
}); };
exports.askAnAgentList = function (props) {
    var headStyle = {
        backgroundImage: "url(" + props.backgroundImage + ")",
        backgroundSize: 'center 23%',
        backgroundAttachment: 'unset',
    };
    var onKeywordChanged = function (event) {
        props.onKeywordChanged(event.currentTarget.value);
    };
    var onKeywordFocus = function () { return props.onKeywordFocus(); };
    var handleKeyPress = function (event) {
        if (event.key === 'Enter') {
            if (props.suggestionSelecting === -1) {
                props.onKeywordEnter();
                props.setKeywordBlur(event.currentTarget);
                return;
            }
            return props.onKeywordSelect();
        }
        if (event.key === 'ArrowUp')
            return props.onKeywordArrowUp();
        if (event.key === 'ArrowDown')
            return props.onKeywordArrowDown();
    };
    var renderListResult = function (it, i) {
        return (React.createElement("div", { className: "c-blogpost__listitem" },
            React.createElement("div", { className: "c-bubble c-bubble--left c-bubble--indent c-bubble--photo" },
                React.createElement("div", { className: "c-bubble__bubble" },
                    React.createElement("div", { className: "c-bubble__indent" },
                        React.createElement("span", { className: "fas fa-user-circle" })),
                    React.createElement("div", { className: "c-bubble__name" }, it.askAuthor),
                    React.createElement("a", { href: it.answerLink, className: "c-bubble__text" }, it.askText),
                    React.createElement("div", { className: "c-bubble__date" }, format_1.default.date(new Date(it.askDate))))),
            React.createElement("div", { className: "c-bubble c-bubble--right c-bubble--indent c-bubble--photo" },
                React.createElement("div", { className: "c-bubble__bubble" },
                    React.createElement("div", { className: "c-bubble__indent" },
                        React.createElement("a", { href: it.answerAuthorLink, className: "c-bubble__photo" },
                            React.createElement("img", { alt: it.answerAuthor, src: it.answerPhoto }))),
                    React.createElement("a", { href: it.answerAuthorLink, className: "c-bubble__name" }, it.answerAuthor),
                    React.createElement("div", { className: "c-bubble__text" },
                        React.createElement("a", { className: "o-textbtn", href: it.answerLink },
                            props.t.viewAnswer,
                            "\u00A0",
                            React.createElement("span", { className: "fal fa-external-link-square" }))),
                    React.createElement("div", { className: "c-bubble__date" }, format_1.default.date(new Date(it.answerDate)))))));
    };
    var renderPager = function (props) {
        return ResultPagination_1.renderPagination(props.listResult.currentPage, props.listResult.totalPage, props.onChangePage, props.resultT, props.currentUrl, AskAnAgentListUrl_1.getAskAnAgentListUrlCallback);
    };
    var keywordRowClass = classNames([
        'c-fsection__row',
        'c-suggestion__box-float',
        {
            'c-suggestion--active': props.suggestionActive,
        },
    ]);
    var renderSuggestionItem = function (text, n) {
        var suggestionItemClass = classNames('c-suggestion__item', {
            'c-suggestion__item--active': props.suggestionSelecting === n,
        });
        var onSuggestItemClick = function () {
            props.onSuggestItemClick(n);
        };
        return (React.createElement("div", { className: suggestionItemClass, onMouseDown: onSuggestItemClick },
            React.createElement("div", { className: "c-suggestion__item-icon" },
                React.createElement("span", { className: "fad fa-file-alt" })),
            React.createElement("div", { className: "c-suggestion__item-text" },
                React.createElement("span", { className: "c-suggestion__item-text-address" }, text))));
    };
    var renderPosts = function (props) {
        return props.listResult.results ? (React.createElement("div", { className: "c-blogpost" },
            React.createElement("div", { className: "c-blogpost__info" },
                props.t.showingPage,
                " ",
                props.listResult.currentPage,
                " /",
                ' ',
                props.listResult.totalPage),
            React.createElement("div", { className: "c-blogpost__list" }, props.listResult.results.map(renderListResult)),
            React.createElement("div", { className: "l-pad l-pad--4 l-pad-top--2" }, renderPager(props)))) : null;
    };
    var renderEmpty = function (props) { return (React.createElement("div", { className: "c-blogpost__empty" },
        React.createElement("div", { className: "c-blogpost__empty-icon" },
            React.createElement("span", { className: "fad fa-file-search" })),
        React.createElement("div", { className: "c-blogpost__empty-main" },
            React.createElement("div", { className: "c-blogpost__empty-head" },
                props.t.noResultTitle,
                " - \"",
                props.searchKeyword,
                "\""),
            React.createElement("div", { className: "c-blogpost__empty-caption" }, props.t.noResultCaption)))); };
    var renderResult = function (props) {
        if (!props.listResult.results)
            return null;
        return props.listResult.results.length
            ? renderPosts(props)
            : renderEmpty(props);
    };
    return (React.createElement(AboutPage_1.default, { currentPage: Pages_1.Pages.ASK_AN_AGENT_LIST, menu: props.menu, title: props.t.pageTitle, headStyle: headStyle },
        React.createElement("div", { className: "c-fsection" },
            React.createElement("h2", { className: "c-fsection__head" }, props.t.searchTitle),
            React.createElement("div", { className: "c-fsection__body" },
                React.createElement("div", { className: keywordRowClass },
                    React.createElement("div", { className: "c-fsection__field" },
                        React.createElement("div", { className: "c-fsection__label" },
                            React.createElement("span", { className: "fal fa-search" })),
                        React.createElement("input", { id: "sfilter-keyword-text", className: "c-fsection__input", type: "text", placeholder: props.t.searchHint, value: props.searchKeyword, onChange: onKeywordChanged, onFocus: onKeywordFocus, onBlur: props.onKeywordBlur, onKeyPress: handleKeyPress, onKeyDown: handleKeyPress })),
                    React.createElement("div", { className: "c-suggestion__pop" },
                        React.createElement("div", { className: "c-suggestion__group" },
                            React.createElement("div", { className: "c-suggestion__list" }, props.suggestions.map(renderSuggestionItem))))))),
        renderResult(props)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.askAnAgentList);
